export interface SubMenuItem {
  name?: string;
  cname?: string;
  code?: string;
  subPages?: SubMenuItem[];
}
